<template>
  <div>
    <div>
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col md="12">
              <b-form-group label="Departamento" label-for="department">
                <v-select v-model="department" :options="options_department" :clearable="false"
                  :reduce="item => item.label" id="department" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group label="Área" label-for="area">
                <v-select multiple v-model="area" :options="options_area" :clearable="false" :reduce="item => item.label"
                  id="area" maxHeight="400px" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group label="Sección" label-for="section">
                <v-select multiple v-model="section" :options="options_section" :clearable="false"
                  :reduce="item => item.label" id="section" maxHeight="400px" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="Tipo de Organigrama" label-for="type">
                <v-select v-model="type" :options="options_type" :clearable="false" :reduce="item => item.key" id="type"
                  maxHeight="400px" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Estado de Planilla" label-for="type">
                <v-select v-model="payroll_status_type" :options="options_payroll_status_type" :clearable="false"
                  :reduce="item => item.key" id="type" maxHeight="400px" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha hasta" label-for="type">
                <flat-pickr id="date_to" v-model="date_to" class="form-control" :config="{
                  mode: 'single',
                  dateFormat: 'Y-m-d',
                  defaultDate: new Date(),
                  locale: 'es',
                  maxDate: new Date(),
                }" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-col md="12">
            <div>
              <b-button variant="success" @click="generateOrgChart" :disabled="isLoading">
                <span class="align-middle">Generar Organigrama</span>
              </b-button>
            </div>
          </b-col>
        </b-card-body>
      </b-card>
      <div v-if="isLoading">
        <div class="text-center">
          <label>Cargando...</label>&nbsp;
          <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
        </div>
      </div>
      <div id="tree" ref="tree"></div>
    </div>
  </div>
</template>

<script>
import axiosIns from '../../../libs/axios'
import OrgChart from '../../../libs/orgchart'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BFormGroup,
  BButton,
  BCardBody,
  VBModal,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BSpinner,
    vSelect,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      nodes: [],
      slinks: [],
      isLoading: false,
      options_department: [],
      options_area: [],
      options_section: [],
      options_type: [
        {
          "key": 1,
          "label": "Mixto",
        },
        {
          "key": 2,
          "label": "Solo Nómina Actual"
        },
        {
          "key": 3,
          "label": "Solo Nomina Solicitado"
        }
      ],
      options_payroll_status_type: [
        {
          "key": 0,
          "label": "Activos",
        },
        {
          "key": 1,
          "label": "Cesados"
        },
        {
          "key": 2,
          "label": "Activos y Cesados"
        }
      ],
      department: null,
      area: null,
      section: null,
      type: 1,
      payroll_status_type: 0,
      date_to: null,
    }
  },
  mounted() {
    this.applyCustomTemplates()
    console.log(OrgChart.isTrial())
  },
  created() {
    this.getOptionsDepartment()
    this.initializeDate()
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    mytree: function (domEl, nodes, slinks) {
      this.chart = new OrgChart(domEl, {
        nodes: nodes,
        slinks: slinks,
        nodeBinding: {
          field_0: "Puesto",
          field_1: "Tipo Labor",
          field_2: "Nombre",
          field_3: "Subdivision"
        },
        enableSearch: false,
        tags: {
          currentPosition: { template: 'current' },
          requestedPosition: { template: 'request' },
          calificado_current: { template: 'calificado_current' },
          calificado_requested: { template: 'calificado_request' },
          nocalificado: { template: 'nocalificado' },
          subLevels0: { subLevels: 0 },
          subLevels1: { subLevels: 1 },
          subLevels2: { subLevels: 2 },
          subLevels3: { subLevels: 3 },
          subLevels4: { subLevels: 4 },
          subLevels5: { subLevels: 5 },
          subLevels6: { subLevels: 6 },
          subLevels7: { subLevels: 7 },
          subLevels8: { subLevels: 8 },
          subLevels9: { subLevels: 9 },
          subLevels10: { subLevels: 10 },
          subLevels11: { subLevels: 11 },
          subLevels12: { subLevels: 12 },
          subLevels13: { subLevels: 13 },
          subLevels14: { subLevels: 14 },
          subLevels15: { subLevels: 15 },
        },
        toolbar: {
          layout: true,
          zoom: true,
          fit: true,
          expandAll: false,
          fullScreen: true
        },
        miniMap: true,
        menu: {
          pdf: { text: "Export PDF" },
          png: { text: "Export PNG" },
          svg: { text: "Export SVG" },
        },
        enableDragDrop: false,
      });
    },
    applyCustomTemplates() {
      OrgChart.templates.current = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.current.size = [300, 100];
      OrgChart.templates.current.node = '<rect x="0" y="0" height="120" width="300" fill="#385723" stroke-width="1" stroke="#aeaeae" rx="5" ry="5"></rect>'
      OrgChart.templates.current.field_0 = '<text width="300" class="field_0" style="font-size: 12px;" fill="#ffffff" x="150" y="30" text-anchor="middle">{val}</text>';
      OrgChart.templates.current.field_3 = '<text width="300" class="field_3" style="font-size: 12px;" fill="#ffffff" x="130" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.current.field_1 = '<text width="300" class="field_1" style="font-size: 12px;" fill="#ffffff" x="180" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.current.field_2 = '<text width="300" class="field_2" style="font-size: 12px;" fill="#D8DF06" x="150" y="75" text-anchor="middle">{val}</text>';

      OrgChart.templates.request = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.request.size = [300, 100];
      OrgChart.templates.request.node = '<rect x="0" y="0" height="120" width="300" fill="#C55A10" stroke-width="1" stroke="#aeaeae" rx="5" ry="5"></rect>'
      OrgChart.templates.request.field_0 = '<text width="300" class="field_0" style="font-size: 12px;" fill="#ffffff" x="150" y="30" text-anchor="middle">{val}</text>';
      OrgChart.templates.request.field_3 = '<text width="300" class="field_3" style="font-size: 12px;" fill="#ffffff" x="130" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.request.field_1 = '<text width="300" class="field_1" style="font-size: 12px;" fill="#ffffff" x="180" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.request.field_2 = '<text width="300" class="field_2" style="font-size: 12px;" fill="#D8DF06" x="150" y="75" text-anchor="middle">{val}</text>';

      OrgChart.templates.calificado_current = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.calificado_current.size = [300, 100];
      OrgChart.templates.calificado_current.node = '<rect x="0" y="0" height="120" width="300" fill="#385723" stroke-width="5" stroke="#F5C242" rx="5" ry="5"></rect>'
      OrgChart.templates.calificado_current.field_0 = '<text width="300" class="field_0" style="font-size: 12px;" fill="#ffffff" x="150" y="30" text-anchor="middle">{val}</text>';
      OrgChart.templates.calificado_current.field_3 = '<text width="300" class="field_3" style="font-size: 12px;" fill="#ffffff" x="130" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.calificado_current.field_1 = '<text width="300" class="field_1" style="font-size: 12px;" fill="#ffffff" x="180" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.calificado_current.field_2 = '<text width="300" class="field_2" style="font-size: 12px;" fill="#D8DF06" x="150" y="75" text-anchor="middle">{val}</text>';

      OrgChart.templates.calificado_request = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.calificado_request.size = [300, 100];
      OrgChart.templates.calificado_request.node = '<rect x="0" y="0" height="120" width="300" fill="#C55A10" stroke-width="5" stroke="#F5C242" rx="5" ry="5"></rect>'
      OrgChart.templates.calificado_request.field_0 = '<text width="300" class="field_0" style="font-size: 12px;" fill="#ffffff" x="150" y="30" text-anchor="middle">{val}</text>';
      OrgChart.templates.calificado_request.field_3 = '<text width="300" class="field_3" style="font-size: 12px;" fill="#ffffff" x="130" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.calificado_request.field_1 = '<text width="300" class="field_1" style="font-size: 12px;" fill="#ffffff" x="180" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.calificado_request.field_2 = '<text width="300" class="field_2" style="font-size: 12px;" fill="#D8DF06" x="150" y="75" text-anchor="middle">{val}</text>';

      OrgChart.templates.nocalificado = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.nocalificado.size = [300, 100];
      OrgChart.templates.nocalificado.node = '<rect x="0" y="0" height="120" width="300" fill="#415F8E" stroke-width="1" stroke="#aeaeae" rx="5" ry="5"></rect>'
      OrgChart.templates.nocalificado.field_0 = '<text width="300" class="field_0" style="font-size: 12px;" fill="#ffffff" x="150" y="30" text-anchor="middle">{val}</text>';
      OrgChart.templates.nocalificado.field_3 = '<text width="300" class="field_3" style="font-size: 12px;" fill="#ffffff" x="130" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.nocalificado.field_1 = '<text width="300" class="field_1" style="font-size: 12px;" fill="#ffffff" x="180" y="55" text-anchor="middle">{val}</text>';
      OrgChart.templates.nocalificado.field_2 = '<text width="300" class="field_2" style="font-size: 12px;" fill="#D8DF06" x="150" y="75" text-anchor="middle">{val}</text>';
    },
    getOptionsDepartment() {
      //const URL = '/nomina/options/DAS'
      const URL = '/nomina/options/DAS'
      const config = {
        method: 'get', url: URL, params: {
          das: 'd',
          element: ''
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_department = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsArea() {
      const URL = '/nomina/options/DAS'
      const config = {
        method: 'get', url: URL, params: {
          das: 'a',
          element: this.department
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_area = response.data.response
            let temp = []
            for (let option of this.options_area) {
              temp.push(option["label"])
            }
            this.area = temp
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsSection() {
      const URL = '/nomina/options/DAS'
      const config = {
        method: 'get', url: URL, params: {
          das: 'ss',
          element: this.department
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_section = response.data.response
            let temp = []
            for (let option of this.options_section) {
              temp.push(option["label"])
            }
            this.section = temp
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    initializeDate() {
      let d = new Date()
      let year = d.getFullYear()
      let month = (d.getMonth() + 1)
      let day = d.getDate()
      this.date_to = year + '-' + month + '-' + day
    },
    generateOrgChart() {
      this.isLoading = true
      this.cleanTree()

      console.log("Iniciando consulta al server")
      const URL = '/nomina/admin/org_chart/get_chart'
      const config = {
        method: 'post', url: URL, data: {
          app_user_id: this.getUserID(),
          department: this.department,
          area: this.area,
          section: this.section,
          type: this.type,
          payroll_status_type: this.payroll_status_type,
          date_to: this.date_to,
        }
      }
      console.log(config)
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            console.log("Consulta completada")
            this.nodes = response.data.nodes
            this.slinks = response.data.slinks
            // Call organization chart
            this.isLoading = false
            this.mytree(this.$refs.tree, this.nodes, this.slinks)
            console.log(this.nodes)
          }
        })
        .catch(error => {
          this.printErrorModal(error)
          this.isLoading = false
        });
    },
    cleanTree() {
      this.mytree(this.$refs.tree, [], [])
    },
  },
  watch: {
    'department'(newArea, oldArea) {
      this.area = null
      this.section = null

      this.getOptionsArea()
      this.getOptionsSection()
    },
    'area'(newSection, oldSection) {
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
